import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'lg',
  children,
  className = '',
  ...props
}) => {
  const baseClasses =
    ' w-full font-semibold rounded-lg transition-colors flex items-center justify-center cursor-pointer';

  const variantClasses = {
    primary:
      'bg-primary text-white hover:bg-primary-600 disabled:bg-gray-300 disabled:text-gray-500',
    secondary:
      'bg-white text-primary border border-primary hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-300',
    outline:
      'bg-white text-primary border border-border-default hover:border-border-hover hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-300',
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 h-8 text-sm leading-5',
    md: 'px-4 py-2 h-10 leading-6',
    lg: 'px-2 py-0.5 h-12 text-lg leading-7',
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
